

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from '@/App'
import router from '@/router'
import './assets/css/common.css'
import i18n from '@/lang/'
import inject from '@/libs/inject'
import commonHelper from './assets/js/common/common'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import cookieHelper from 'js-cookie'
import eventLib from '@/libs/eventLib';
import filters from '@/filters/filters';
import statusBus from '@/libs/statusBus'


Vue.use(VueRouter);
Vue.use(inject, {});
Vue.use(ToastPlugin);
Vue.use(ConfirmPlugin);

Object.keys(filters).forEach(key => {
Vue.filter(key, filters[key])
});


var canSite_switch = cookieHelper.get('site_switch'); 
if (!canSite_switch) {
eventLib.once('initAppConfig', function (appConfig) {
const E_INIT_MVNO = 'eventInitMvno';

const proto = Vue.prototype;
proto.commonHelper = commonHelper(appConfig);
Vue.mixin({
methods: {
apiReady(){

}
},
created(){
if (proto.mvno) {
this.apiReady();
} else {
eventLib.once(E_INIT_MVNO, () => {
this.apiReady();
});
}
}
});
cookieHelper.set("language", "zh-CN", {expires: 1, domain: "." + location.hostname});
const mvno = proto.mvno = staticData.getMvnoCode;

Vue.prototype.ObjectMvno = mvno;
eventLib.emit(E_INIT_MVNO, mvno);
app_init();
function app_init(){
var lang = cookieHelper.get("language");

if (lang === "zh-CN") {
i18n.locale = 'zh'
} else if (lang === "zh-TW" || lang === "zh-HK") {
i18n.locale = 'tw'
} else if (lang === "en-US") {
i18n.locale = 'en'
} else {

i18n.locale = 'en'
}
initRouter();
}
});
}

function initRouter() {
let Router = new VueRouter({
...router,
scrollBehavior(to, from, savedPosition) {
return { x: 0, y: 0 }
}
});

function getParams(str1, pagePath) {
let obj = {};
if (typeof(str1) === 'string') {
let arrPagePath,
reg = new RegExp(str1);
arrPagePath = pagePath.split("/");
for (let i = 0; i < arrPagePath.length; i++) {
if (reg.test(arrPagePath[i])) {
obj[str1] = decodeURIComponent(arrPagePath[i].substring(str1.length + 1));
}
}
}
return obj;
}

Router.beforeEach((to, from, next) => {
let reg = /\/users\/login/,
flag = false;
if (reg.test(to.path)) { // 匹配登录页路由
return next();
} else {
to.matched.forEach((items => {
if (items.meta && items.meta.requiresAuth === true) {
flag = true;
return false;
}
}));
if (flag && !Vue.prototype.cookieHelper.get("access_token")) {
return next({
path: "/users/login",
query: {
returnUrl: to.path
}
});
} else {
let reg1 = /\/data_package\/settlement/;
if(reg1.test(to.redirectedFrom)){
let param1 = getParams('goodsCode', to.redirectedFrom);
let param2 = getParams('categoryCode', to.redirectedFrom);
if (param2.categoryCode) {
return next({path: "/data_package/settlement?goodsCode=" + param1.goodsCode +"&categoryCode=" + param2.categoryCode.replace(/\?/g,"&")});
} else {
return next({path: "/data_package/settlement?goodsCode=" + param1.goodsCode.replace(/\?/g,"&")});
}
}

next();
}
}
if (from.path === to.path) return
});

Router.afterEach((to) => {
if (to.query && to.query.openid) {
localStorage.setItem("openid", to.query.openid);
}

try {
let fn_str = staticData.thirdPartyCode.mobile.thirdPartyFn;
let f = new Function('to', fn_str);
f(to);
} catch (e) {
console.log(e);
}
});

const thisApp = new Vue({
router : Router,
i18n,
render: h => h(App)
}).$mount('#app-box');


eventLib.on('loginTimeout', () => {









onHide()
});
function onHide() {
if (thisApp.$route.query && thisApp.$route.query.returnUrl) {
thisApp.$router.push({path: '/', query: {returnUrl: thisApp.$route.query.returnUrl}});
} else {
thisApp.$router.push({path: '/', query: {returnUrl: thisApp.$route.fullPath}});
}
}
}
Vue.prototype.cookieHelper = cookieHelper;
Vue.prototype.NotInterceptors = false; 




Vue.config.productionTip = false;


if(location.search.indexOf('_render=1') !== -1){
let timeout = location.search.match(/tit=(\d+)/);
if(timeout) timeout = Number(timeout[1]) || 7000;
else timeout = 7000;
setTimeout(function(){
window.name = document.documentElement.outerHTML;
}, timeout);
}



// WEBPACK FOOTER //
// ./src/main.js